export const CONSECUTIVE_OT_RULE_CONFIG = {
	"consecutive-day": {
		overtimeKey: "consecutive-day",
		checkboxLabelKey: "consecutive-day-after",
		modalTitleKey: "consecutive-day-rule-parameters",
	},
	"four-consecutive-day": {
		overtimeKey: "four-consecutive-day",
		checkboxLabelKey: "four-consecutive-day",
		modalTitleKey: "four-consecutive-day-rule-parameters",
	},
	"five-consecutive-day": {
		overtimeKey: "five-consecutive-day",
		checkboxLabelKey: "five-consecutive-day",
		modalTitleKey: "five-consecutive-day-rule-parameters",
	},
	"six-consecutive-day": {
		overtimeKey: "six-consecutive-day",
		checkboxLabelKey: "six-consecutive-day",
		modalTitleKey: "six-consecutive-day-rule-parameters",
	},
};
